import { render, staticRenderFns } from "./GroupIndex.vue?vue&type=template&id=138b1eae&"
import script from "./GroupIndex.vue?vue&type=script&lang=js&"
export * from "./GroupIndex.vue?vue&type=script&lang=js&"
import style0 from "./GroupIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports